<script>
  import { createEventDispatcher } from "svelte";

  const dispatch = createEventDispatcher();

  let activeResult = 0;
  let amount;
  let searchTerm = "";
  let results = [];
  let unit = "";

  const handleInput = () => {
    const [_amount, term] = searchTerm.split(" ");

    [amount, unit] = _amount.match(/[a-z]+|[^a-z]+/gi);
    if (term) {
      console.log(amount);
      fetch("/api/search?term=" + term)
        .then(res => res.json())
        .then(json => (results = json));
    }
  };

  function handleResultClick(food) {
    food.amount = amount;
    food.unit = unit;
    dispatch("addFood", {
      food
    });
    results = [];
    searchTerm = "";
  }

  function handleSubmit() {
    handleResultClick(results[0]);
  }
</script>

<style>
  ul.search-list {
    position: absolute;
    width: 100%;
    top: calc(100% + 4px);
  }
</style>

<h4>Sök mat</h4>
<form on:submit|preventDefault={handleSubmit}>
  <div class="input-group mb-3">
    <input
      class="form-control"
      on:input={handleInput}
      bind:value={searchTerm}
      placeholder="Ex. 50g Bacon" />
    <div class="input-group-append">
      <button class="btn btn-outline-secondary" type="button">Find</button>
    </div>

    {#if results && results.length > 0 && searchTerm !== ''}
      <ul class="search-list list-group">
        {#each results as result, index}
          <li
            class="list-group-item {index === activeResult ? 'active' : ''}"
            on:click={() => handleResultClick(result)}
            on:mouseover={() => (activeResult = index)}>
            {result.Livsmedelsnamn}
          </li>
        {/each}
      </ul>
    {/if}

  </div>
</form>
